export const STATE_KEY = 'theatreList';
export const SITE_LIST_FETCH_KEY = `fetch.${STATE_KEY}`;
export const SITE_LAZY_LOAD_FETCH_KEY = `fetch.${STATE_KEY}.lazy-load`;
export const SITE_FORMATS_FETCH_KEY = `fetch.${STATE_KEY}.formats`;

export const THEATRES_LIST_PAGE_SIZE = 20;
